import Vue from 'vue'
import mk from './MK'
import router from './router'
import Antd from 'ant-design-vue'
import store from './store'
import request from 'utils/request'
import socketApi from './utils/webSocket'
import db from 'utils/localstorage'
import VueApexCharts from 'vue-apexcharts'
import * as mathjs from 'mathjs'
import numeral from 'numeral'
import animated from 'animate.css'
import '../static/iconfont/font.css'
import '../static/iconfont/iconfont.js'
import global_ from './components/tool/Global'//全局常量
import * as echarts from "echarts";
Vue.prototype.GLOBAL = global_;
Vue.prototype.$echarts = echarts;

import vRegion from 'v-region'//中国行政区划选择器
Vue.use(vRegion)

import 'viewerjs/dist/viewer.css'//图片点击放大预览
import Viewer from 'v-viewer'
Vue.use(Viewer)

import FullCalendar from 'vue-full-calendar'
Vue.use(FullCalendar)

import 'ant-design-vue/dist/antd.less'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import 'utils/install'

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(db)
Vue.use(VueApexCharts)
Vue.use(animated)

Vue.component('apexchart', VueApexCharts)
Vue.component(VueQrcode.name, VueQrcode)

Vue.use({
  install (Vue) {
    Vue.prototype.$db = db
  }
})

Vue.filter('formatMoney', function (val) {
  return numeral(val).format('0,0.00');
});

Vue.filter('numeralFmt',function(value,fmt){
  return numeral(value).format(fmt);
});

router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})

Vue.prototype.$post = request.post
Vue.prototype.$get = request.get
Vue.prototype.$put = request.put
Vue.prototype.$delete = request.delete
Vue.prototype.$export = request.export
Vue.prototype.$download = request.download
Vue.prototype.$upload = request.upload
Vue.prototype.$stream = request.stream
Vue.prototype.$socketApi = socketApi
Vue.prototype.$math = mathjs
Vue.prototype.$numeral = numeral
Vue.prototype.$lodash = require('lodash')

const Bus = new Vue()
/* eslint-disable no-new */
new Vue({
  router,
  store,
  data:{
    Bus
  },
  render: h => h(mk)
}).$mount('#mk')



// WEBPACK FOOTER //
// ./src/main.js